import { render, staticRenderFns } from "./TransferOfEquityQuestionnaire.vue?vue&type=template&id=329975aa&"
import script from "./TransferOfEquityQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./TransferOfEquityQuestionnaire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports